module.exports = __webpack_public_path__ + "static/media/elements_line_start_vertical_red.c21bdd00.svg";